/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ThreeActionButton.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { Box } from "@mui/material";
import React from "react";
import CustomButtonV2 from "../../button/CustomButtonV2";

function ThreeActionButton({
  onClickSuccess,
  onClickReject,
  successButtonName,
  rejectButtonName,
  otherButtonName,
  onOtherButtonClick,
  disabled = true,
  onDisabled = false,
  rejectDisabled = false,
  rejectButtonType = "cancel",
  typeForThree,
  otherButtonPlacement = "right",
}) {
  const rejectButton = rejectButtonName ? (
    <CustomButtonV2
      type={rejectButtonType}
      btnName={rejectButtonName}
      handleOnClick={onClickReject}
      disabled={rejectDisabled}
    />
  ) : null;

  const otherButton = otherButtonName ? (
    <CustomButtonV2
      type={typeForThree}
      disabled={disabled}
      btnName={otherButtonName}
      handleOnClick={onOtherButtonClick}
    />
  ) : null;

  if (otherButtonPlacement === "left") {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
      >
        <Box>{otherButton}</Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          {rejectButton}
          <CustomButtonV2
            type="submit"
            btnName={successButtonName}
            handleOnClick={onClickSuccess}
            disabled={onDisabled}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
    >
      <Box>
        {rejectButton}
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        <CustomButtonV2
          type="submit"
          btnName={successButtonName}
          handleOnClick={onClickSuccess}
          disabled={onDisabled}
        />
        {otherButton}
      </Box>
    </Box>
  );
}

export default ThreeActionButton;
